/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { UserProfileDropdown } from "./dropdowns/UserProfileDropdown";
import { toAbsoluteUrl } from "../../../_helpers";
import SVG from "react-inlinesvg";
import Badge from '@material-ui/core/Badge';

export function QuickUserToggler() {
  const { user } = useSelector(state => state.auth);
  let [approvalRequestCount, setApprovalRequestCount] = useState(0)

  const loadResult = async () => {
    if(window.approvalCount!==undefined){
      setApprovalRequestCount(window.approvalCount);
    }
  }

  useEffect(() => {
    loadResult()
    let interval = setInterval(loadResult, 5000)
    return () => {
      clearInterval(interval)
    }
  }, []);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas: objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);

  return (<>
    {user && (user.admin_type === 'SUPER_ADMIN' || user.admin_type === 'ADMIN') && layoutProps.offcanvas && (<OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="quick-user-tooltip">View user</Tooltip>}
    >
      <>
        <div className="topbar-item">
          <div className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
            id="kt_quick_user_toggle">
            <>
              <span className="symbol symbol-35 symbol-light-success">
                <span className="svg-icon svg-icon-xl">
                  <Badge badgeContent={approvalRequestCount} className={"dangerBadge"}>
                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
                  </Badge>
                </span>
              </span>
            </>
          </div>
        </div>
      </>
    </OverlayTrigger>)}

    {!layoutProps.offcanvas && (<UserProfileDropdown />)}
  </>
  );
}

